// extracted by mini-css-extract-plugin
export default {"container":"TextWithHintIcon_container__0QEO9","title":"TextWithHintIcon_title__Rze5U"};